import { GateGlyph } from "@/components/brand/gate-glyph";

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" className="size-7" aria-hidden>
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l3.66-2.84z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"
      />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg viewBox="0 0 24 24" className="size-7 fill-foreground" aria-hidden>
      <path d="M17.05 12.04c-.03-2.55 2.08-3.77 2.18-3.84-1.19-1.74-3.04-1.98-3.7-2.01-1.57-.16-3.07.93-3.87.93-.8 0-1.95-.91-3.21-.88-1.65.02-3.17.96-4.02 2.44-1.71 2.97-.44 7.36 1.23 9.78.81 1.18 1.78 2.51 3.05 2.46 1.22-.05 1.68-.79 3.16-.79 1.47 0 1.89.79 3.18.76 1.31-.02 2.14-1.2 2.95-2.39.93-1.37 1.31-2.7 1.33-2.77-.03-.01-2.55-.98-2.57-3.88zM14.53 4.5c.68-.83 1.14-1.97 1.01-3.12-.98.04-2.16.65-2.86 1.48-.63.73-1.18 1.9-1.03 3.02 1.09.09 2.2-.55 2.88-1.38z" />
    </svg>
  );
}

function EthIcon() {
  return (
    <svg viewBox="0 0 24 24" className="size-7" aria-hidden>
      <path fill="#627eea" d="M12 2 6 12l6 3.5L18 12 12 2z" />
      <path fill="#627eea" opacity="0.6" d="M6 13.2 12 22l6-8.8L12 16.7 6 13.2z" />
    </svg>
  );
}

const PROVIDERS = [
  { label: "Continue with Google", Icon: GoogleIcon },
  { label: "Continue with Apple", Icon: AppleIcon },
  { label: "Continue with Ethereum", Icon: EthIcon },
];

/**
 * A mock of the embeddable moongate wallet adapter, styled to match the real
 * app login screen (apps/mobile/src/app/login.tsx): the gate mark + lowercase
 * "moongate" wordmark stacked, above a row of circular provider buttons.
 */
export function WalletAdapter() {
  return (
    <div className="relative flex w-full flex-col items-center px-4 text-center">
      {/* Soft glow behind the gate — echoes the login screen's vignette. */}
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-0 -z-10 size-48 -translate-x-1/2 rounded-full bg-primary/15 blur-[60px]"
      />

      <GateGlyph size={52} className="text-primary dark:text-white" />
      <span
        className="mt-3 bg-gradient-to-r from-muted-foreground via-foreground to-muted-foreground bg-clip-text pb-[0.12em] text-3xl font-semibold lowercase leading-[1.4] tracking-[-0.04em] text-transparent"
        style={{ fontFamily: "var(--font-lexend)" }}
      >
        moongate
      </span>

      <div className="mt-10 flex items-center justify-center gap-5">
        {PROVIDERS.map(({ label, Icon }) => (
          <button
            key={label}
            type="button"
            aria-label={label}
            className="grid size-14 place-items-center rounded-full border border-border transition-colors hover:border-primary/50 hover:bg-muted/50"
          >
            <Icon />
          </button>
        ))}
      </div>
    </div>
  );
}
